import React, { useEffect, useState } from "react";

import { Avatar, Grid, Stack, TextField, Typography } from "@mui/material";

import KRAStyles from "../pages/Styles/KRAScreen.module.scss";
import ProgressBar from "../Components/ProgressBar/ProgressBar";
import SideBar from "../Components/SideBar/SideBar";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MenuIcon from "@mui/icons-material/Menu";

interface Props {
  aadhaarData: any;
}

export default function KRAScreen({ aadhaarData }: Props) {
  const [fetechedDetails, setfetechedDetails] = useState(true);
  const [expandMenu, setExpandMenu] = useState<any>(false);

  //  console.log(aadhaarData);

  return (
    <>
      {fetechedDetails ? (
        <div className={KRAStyles?.wrapper}>
          <div className={KRAStyles.headerSection}>
            <p className={KRAStyles.header}>
              <div className={KRAStyles.mobileBack}>
                {/* <ArrowBackIosIcon /> */}
              </div>
              KRA fetched details
              <div
                className={KRAStyles.mobileMenu}
                onClick={() => {
                  setExpandMenu(!expandMenu);
                }}
              >
                {expandMenu ? <CloseIcon /> : <MenuIcon />}
              </div>
            </p>
            <ProgressBar />
            <div
              className={KRAStyles.mobileexpandedMenu}
              style={{
                height: expandMenu ? "100%" : "0%",
              }}
            >
              <div className={KRAStyles.mobilemenuContent}>
                <SideBar />
              </div>
            </div>
            <p className={KRAStyles.desc}>
              Please review your KRA details and verify to proceed
            </p>
          </div>
          <div className={KRAStyles.containerData}>
            <Grid
              container
              rowSpacing={{ xs: 2, sm: 6 }}
              columnSpacing={{ xs: 1, sm: 2, md: 5 }}
            >
              <Grid item xs={12} md={4}>
                <div className={KRAStyles.itemWrap}>
                  <div className={KRAStyles.labeltext}>Name As per PAN</div>
                  <div className={KRAStyles.value}>
                    {aadhaarData?.kra_name}
                  </div>
                </div>
                {/* <TextField
                  fullWidth
                  id="outlined-basic"
                  placeholder="Name As per PAN"
                  variant="outlined"
                  value={aadhaarData?.kra_name}
                  // value={"hhhhhhhh"}
                  sx={{
                    fieldset: {
                      borderColor: "none",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                /> */}
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={KRAStyles.itemWrap}>
                  <div className={KRAStyles.labeltext}>Father Name</div>
                  <div className={KRAStyles.value}>
                    {aadhaarData?.father_name}
                  </div>
                </div>
                {/* <TextField
                  fullWidth
                  id="outlined-basic"
                  placeholder="Father Name"
                  variant="outlined"
                  value={aadhaarData?.father_name}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                /> */}
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={KRAStyles.labeltext}>Date of Birth</div>
                <div className={KRAStyles.value}>{aadhaarData?.kra_dob}</div>
                {/* <TextField
                  fullWidth
                  id="outlined-basic"
                  placeholder="Date of Birth"
                  variant="outlined"
                  value={aadhaarData?.kra_dob}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                /> */}
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={KRAStyles.itemWrap}>
                  <div className={KRAStyles.labeltext}>Gender</div>
                  <div className={KRAStyles.value}>{aadhaarData?.gender}</div>
                </div>
                {/* <TextField
                  fullWidth
                  id="outlined-basic"
                  placeholder="Gender"
                  variant="outlined"
                  value={aadhaarData?.gender}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                /> */}
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                // justifyContent={"center"}
                // margin={"auto"}
              >
                <div className={KRAStyles.itemWrap}>
                  <div className={KRAStyles.labeltext}>Email</div>
                  <div className={KRAStyles.value}>
                    {aadhaarData?.kra_email?.toLowerCase()}
                  </div>
                </div>
                {/* <TextField
                  fullWidth
                  id="outlined-basic"
                  placeholder="Email"
                  variant="outlined"
                  value={aadhaarData?.kra_email?.toLowerCase()}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                /> */}
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                // justifyContent={"center"}
                // margin={"auto"}
              >
                <div className={KRAStyles.labeltext}>Pincode</div>
                <div className={KRAStyles.value}>{aadhaarData?.pincode}</div>
                {/* <TextField
                  fullWidth
                  id="outlined-basic"
                  placeholder="Pincode"
                  variant="outlined"
                  value={aadhaarData?.pincode}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                /> */}
              </Grid>
              <Grid item xs={12}>
                <div className={KRAStyles.labeltext}>Address</div>
                <div className={KRAStyles.value}>{aadhaarData?.address}</div>
                {/* <TextField
                  fullWidth
                  id="outlined-basic"
                  placeholder="Address"
                  variant="outlined"
                  value={aadhaarData?.address}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                /> */}
              </Grid>
            </Grid>
          </div>
        </div>
      ) : (
        <Stack>
          <Typography>No Details Fetched</Typography>
        </Stack>
      )}
    </>
  );
}
